import React from 'react';
import { Box, Typography } from '@mui/material';

const GradientHeader = ({ title, icon }) => {
  return (
    <Box sx={{ 
      background: 'linear-gradient(to right, #09274A, #0488AF)',
      p: 2,
      color: 'white',
      borderTopLeftRadius: '12px',
      borderTopRightRadius: '12px',
    }}>
      <Typography variant="h5" sx={{ 
        fontWeight: 700,
        display: 'flex',
        alignItems: 'center',
        gap: 1
      }}>
        {icon} {title}
      </Typography>
    </Box>
  );
};

export default GradientHeader;